import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "defeat-boss",
    "stage": {
        "image": require("./image.png"),
        "imageOffset": {"x": -6, "y": -1},
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "width": 18,
            "height": 10,
        }),
        "text": function(stage) {
            return "Defeat Saul"
        },
        "conditions": [
            ...convertOldChapterScripting({
                "0:start": [
                    {"type": "Wait", "time": 0.5},
                    {
                        "type": "MoveUnit",
                        "position": {"x": 2, "y": 7},
                        "classKey": "oriana",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 1, "y": 7},
                        "classKey": "brigid",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 0, "y": 7},
                        "classKey": "callista",
                    },
                    {"type": "Wait", "time": 0.5},
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "oriana",
                            "text": "Saul!! Show yourself!!",
                            "expression": "angry",
                        }
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 2, "y": 2},
                        "classKey": "saul",
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "saul", "side": "right",
                            "text": "Oriana, back again?",
                            "expression": "happy",
                        }
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "saul", "side": "right",
                            "text": "I thought you were dead?",
                            "expression": "sly",
                        }
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "oriana",
                            "text": "Not yet. En garde!",
                        }
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "callista",
                            "text": "This is it! Our second chance.",
                            "expression": "stern",
                        }
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "brigid",
                            "text": "We're stronger now. Let's give it our all!",
                            "expression": "frowny",
                        }
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 3, "y": 2},
                        "classKey": "#A",
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "saul", "side": "right",
                            "text": "Forward! Stop them!",
                        }
                    },
                    {
                        "type": "StopDialogue",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 2, "y": 4},
                        "classKey": "#B",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 3},
                        "classKey": "#C",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 0, "y": 1},
                        "classKey": "#D",
                    },
                ],
                "3:end": [
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "Saul", "side": "right",
                            "text": "They're advancing closer...",
                        }
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "Saul", "side": "right",
                            "text": "Bring out all reinforcements!!",
                        }
                    },
                    {
                        "type": "StopDialogue",
                    },
                    {
                        "type": "SpawnUnit",
                        "spawn": {
                            "key": "#1",
                            "position": {"x": 6, "y": 1},
                            "classKey": "berserker",
                            "affiliation": "bad",
                            "maxhealth": 40,
                        },
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 1},
                        "classKey": "#1",
                    },
                    {
                        "type": "SpawnUnit",
                        "spawn": {
                            "key": "#2",
                            "position": {"x": 6, "y": 2},
                            "classKey": "berserker",
                            "affiliation": "bad",
                            "maxhealth": 40,
                        },
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 2},
                        "classKey": "#2",
                    }
                ],
                "7:end": [
                    {
                        "type": "SpawnUnit",
                        "spawn": {
                            "key": "francois",
                            "position": {"x": 6, "y": 6},
                            "classKey": "paladin",
                            "affiliation": "bad",
                            "health": 10
                        },
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "Francois", "side": "right",
                            "text": "I came as fast as I could!!",
                        }
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 6},
                        "classKey": "francois",
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "Francois", "side": "right",
                            "text": "Tch - they got here before me.",
                        }
                    },
                    {
                        "type": "StopDialogue"
                    }
                    // {
                    //     "type": "SpawnUnit",
                    //     "spawn": {
                    //         "key": "#4",
                    //         "position": {x: 5, y: 8},
                    //         "classKey": "berserker",
                    //         "affiliation": "bad",
                    //     },
                    // },
                    // {
                    //     "type": "MoveUnit",
                    //     "position": {x: 5, y: 7},
                    //     "classKey": "#4",
                    // }
                ],
            }, "/games/hero/credits"),
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.units["saul"].isDead == true
                },
                "events": [
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/hero/credits")},
                ]
            },
        ]
    }
}

// "defeat-boss": {
//     "music": "hero",
//     "hasPreparation": false, // DEBUG
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/grasslands-castle.png"),
//         "tiles": [
//             // {"position": {x: 0, y: 4}, "passable": false},
//             // {"position": {x: 1, y: 4}, "passable": false},
//             // {"position": {x: 2, y: 4}, "passable": false},
//             // {"position": {x: 4, y: 4}, "passable": false},
//             // {"position": {x: 5, y: 4}, "passable": false},
//             {"position": {"x": 0, "y": 0}, "passable": false},
//             {"position": {"x": 1, "y": 0}, "passable": false},
//             {"position": {"x": 2, "y": 0}, "passable": false},
//             {"position": {"x": 3, "y": 0}, "passable": false},
//             {"position": {"x": 4, "y": 0}, "passable": false},
//             {"position": {"x": 5, "y": 0}, "passable": false},
//             {"position": {"x": 1, "y": 1}, "passable": false},
//             {"position": {"x": 2, "y": 1}, "passable": false},
//             // {"position": {x: 3, y: 2}, "passable": false},
//             // {"position": {x: 1, y: 2}, "passable": false},
//             // {"position": {x: 2, y: 2}, "passable": false},
//             {"position": {"x": 3, "y": 1}, "passable": false},
//             {"position": {"x": 0, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 3}, "passable": false},
//             {"position": {"x": 3, "y": 3}, "passable": false},
//             {"position": {"x": 4, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 5}, "passable": false},
//             {"position": {"x": 2, "y": 5}, "passable": false},
//             {"position": {"x": 4, "y": 5}, "passable": false},
//             {"position": {"x": 5, "y": 5}, "passable": false},
//             {"position": {"x": 1, "y": 6}, "passable": false},
//             // {"position": {x: 4, y: 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/desert/objects/cactus_1.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 2, "y": 8}, "affiliation": "good"},
//         {"position": {"x": 1, "y": 8}, "affiliation": "good"},
//         {"position": {"x": 0, "y": 8}, "affiliation": "good"},
//         {"position": {"x": 2, "y": -1}, "affiliation": "bad", "classKey": "cleric", "key": "saul"},
//         {"position": {"x": -1, "y": 4}, "affiliation": "bad", "classKey": "berserker", "key": "#B"},
//         {"position": {"x": 6, "y": 3}, "affiliation": "bad", "classKey": "berserker", "key": "#C"},
//         {"position": {"x": -1, "y": 1}, "affiliation": "bad", "classKey": "archer", "key": "#D"},
//     ],
//     "events": {
//         "0:start": [
//             {"type": "Wait", "time": 0.5},
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 7},
//                 "classKey": "oriana",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 1, "y": 7},
//                 "classKey": "brigid",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 7},
//                 "classKey": "callista",
//             },
//             {"type": "Wait", "time": 0.5},
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana",
//                     "text": "Saul!! Show yourself!!",
//                 }
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 2},
//                 "classKey": "saul",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "Oriana, back again?",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "I thought you were dead?",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana",
//                     "text": "Not yet. En garde!",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "callista",
//                     "text": "This is it! Our second chance.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "brigid",
//                     "text": "We're stronger now. Let's give it our all!",
//                 }
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 3, "y": 2},
//                 "classKey": "#A",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "Forward! Stop them!",
//                 }
//             },
//             {
//                 "type": "StopDialogue",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 4},
//                 "classKey": "#B",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 3},
//                 "classKey": "#C",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 1},
//                 "classKey": "#D",
//             },
//         ],
//         "3:end": [
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "They're advancing closer...",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "Bring out all reinforcements!!",
//                 }
//             },
//             {
//                 "type": "StopDialogue",
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 6, "y": 1},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 1},
//                 "classKey": "#1",
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#2",
//                     "position": {"x": 6, "y": 2},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 2},
//                 "classKey": "#2",
//             }
//         ],
//         "7:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "francois",
//                     "position": {"x": 6, "y": 6},
//                     "classKey": "paladin",
//                     "affiliation": "bad",
//                     "health": 2
//                 },
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Francois", "side": "right",
//                     "text": "I came as fast as I could!!",
//                 }
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 6},
//                 "classKey": "francois",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Francois", "side": "right",
//                     "text": "Tch - they got here before me.",
//                 }
//             },
//             {
//                 "type": "StopDialogue"
//             }
//             // {
//             //     "type": "SpawnUnit",
//             //     "spawn": {
//             //         "key": "#4",
//             //         "position": {x: 5, y: 8},
//             //         "classKey": "berserker",
//             //         "affiliation": "bad",
//             //     },
//             // },
//             // {
//             //     "type": "MoveUnit",
//             //     "position": {x: 5, y: 7},
//             //     "classKey": "#4",
//             // }
//         ],
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "CreditsScreen"},
//     ],
//     "nextUrl": "/credits",
// },
